var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOffIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.82009 3.59232C10.2265 3.53223 10.6458 3.5 11.0776 3.5C16.1826 3.5 19.5324 8.00484 20.6578 9.78682C20.7941 10.0025 20.8622 10.1103 20.9003 10.2767C20.9289 10.4016 20.9289 10.5987 20.9002 10.7236C20.8621 10.8899 20.7935 10.9985 20.6563 11.2156C20.3565 11.6901 19.8993 12.3571 19.2936 13.0805M5.80147 5.21504C3.6394 6.6817 2.1716 8.71938 1.49825 9.78528C1.36143 10.0019 1.29302 10.1102 1.25489 10.2765C1.22625 10.4014 1.22623 10.5984 1.25486 10.7234C1.29298 10.8897 1.36108 10.9975 1.49728 11.2132C2.62269 12.9952 5.97256 17.5 11.0776 17.5C13.136 17.5 14.909 16.7676 16.366 15.7766M2.07756 1.5L20.0776 19.5M8.95624 8.37868C8.41335 8.92157 8.07756 9.67157 8.07756 10.5C8.07756 12.1569 9.42071 13.5 11.0776 13.5C11.906 13.5 12.656 13.1642 13.1989 12.6213",
    stroke: "#7BA4D5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOffIcon);
export default __webpack_public_path__ + "static/media/eyeOffIcon.4cc986993ee8677b85d713209c568144.svg";
export { ForwardRef as ReactComponent };